var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.estados_de_pago, function(estado, index) {
      return _c("div", { key: index }, [
        estado.code == _vm.doc.estadoComercial
          ? _c("div", [_vm._v(" " + _vm._s(estado.label) + " ")])
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }